import { render, staticRenderFns } from "./modal-window.vue?vue&type=template&id=17aff686"
import script from "./modal-window.vue?vue&type=script&lang=js"
export * from "./modal-window.vue?vue&type=script&lang=js"
import style0 from "./modal-window.vue?vue&type=style&index=0&id=17aff686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports